import IntegrationsListTab from "@/components/IntegrationsListTab"
import TabNavigation from "@/components/TabNavigation"
import UserInfo from "@/components/UserInfo"

export default function IntegrationsPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <div className="text-center flex-1">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">
              Financial Integration API
            </h1>
          </div>
          <div className="flex-shrink-0">
            <UserInfo />
          </div>
        </div>

        <div className="space-y-4">
          <TabNavigation />
          <div className="space-y-4">
            <IntegrationsListTab />
          </div>
        </div>
      </div>
    </div>
  )
}

